import ScreenExpiredAdList from 'screens/ExpiredAd/List';
import ScreenAdDetails from 'screens/Ad/Details';
import { EXPIRED_AD } from 'routes/paths';

const expiredAdsRoutes = [
  {
    path: EXPIRED_AD.DETAILS,
    name: 'ExpiredAdDetails',
    component: ScreenAdDetails,
  },
  {
    path: EXPIRED_AD.LIST,
    name: 'ExpiredAdList',
    component: ScreenExpiredAdList,
    loginRequired: true,
  },
];

export default expiredAdsRoutes;
